import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: { width: '100%' },
});

export default styles;
